import { useTranslation } from "react-i18next";
import SuccessIcon from '../../assets/Success.svg'; 
import SupportIcon from '../../assets/Support.svg';
import { Button } from "mobily-ui-library/lib";
import './SuccessModal.scss';

interface Props {
    rtl: boolean;
}

function SuccessModal({ rtl }: Props) {
    const { t } = useTranslation();
    return (
        <div className="success-container">
            <img src={SuccessIcon} alt='success-icon' className="success-icon" />
            <div className="success-title">
                {t('Your_request_has_been_received')}
            </div>
            <div className="success-sub-container">
                <img src={SupportIcon} alt='support-icon' />
                <div className="text-center mt-2">{t('Mobily_sale_agent_will_contact')}</div>
            </div>
            <Button width={"155px"} onClick={()=>window.history.back()}>
                {t('GOT_IT')}
            </Button>
        </div>
    )
}

export default SuccessModal